import { useState } from "react";

const usePagination = (data, itemsPerPage) => {
  const [currentPage, setCurrentPage] = useState(1);
  const maxPage = Math.ceil(data?.length / itemsPerPage);

  const currentData = () => {
    const begin = (currentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    return data?.slice(begin, end).map((item, index) => ({
      ...item,
      indexNumber: index + begin,
      indexData: index + begin + 1
    }));
  };

  const next = () => {
    setCurrentPage(currentPage => Math.min(currentPage + 1, maxPage));
  };

  const prev = () => {
    setCurrentPage(currentPage => Math.max(currentPage - 1, 1));
  };

  const jump = page => {
    const pageNumber = Math.max(1, page);
    const jumpTo = Math.min(pageNumber, maxPage);
    setCurrentPage(jumpTo ? jumpTo : 1);
  };

  const toFirst = () => {
    jump(1);
  };

  const toLast = () => {
    jump(maxPage);
  };

  const disableNext = () => currentPage === maxPage;

  const disableLast = () => currentPage === maxPage;

  const disablePrev = () => currentPage === 1;

  const disableFirst = () => currentPage === 1;

  const lastestPageItemNumber = data?.length % itemsPerPage;

  return {
    next,
    prev,
    jump,
    currentData,
    currentPage,
    maxPage,
    toFirst,
    toLast,
    disableNext,
    disableLast,
    disablePrev,
    disableFirst,
    lastestPageItemNumber
  };
};

export default usePagination;
